
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("eIdh3"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("eIdh3", function(module, exports) {

let $ab5f78b58ca0b1e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab5f78b58ca0b1e2$var$load("h3ABO"),
    $ab5f78b58ca0b1e2$var$load("3Tca0"),
    $ab5f78b58ca0b1e2$var$load("djHM5"),
    $ab5f78b58ca0b1e2$var$load("eJQji"),
    $ab5f78b58ca0b1e2$var$load("4jlMu"),
    $ab5f78b58ca0b1e2$var$load("2YffH"),
    $ab5f78b58ca0b1e2$var$load("2VmDq"),
    $ab5f78b58ca0b1e2$var$load("6mHrv"),
    $ab5f78b58ca0b1e2$var$load("awWN9"),
    $ab5f78b58ca0b1e2$var$load("9CYct"),
    $ab5f78b58ca0b1e2$var$load("98Tkp"),
    $ab5f78b58ca0b1e2$var$load("fmbv3"),
    $ab5f78b58ca0b1e2$var$load("hZtKG"),
    $ab5f78b58ca0b1e2$var$load("dkqvW"),
    $ab5f78b58ca0b1e2$var$load("lVO3w"),
    $ab5f78b58ca0b1e2$var$load("hyzoX"),
    $ab5f78b58ca0b1e2$var$load("h9Ed7"),
    $ab5f78b58ca0b1e2$var$load("eBRUf"),
    $ab5f78b58ca0b1e2$var$load("kbRvk"),
    $ab5f78b58ca0b1e2$var$load("tKhaz"),
    $ab5f78b58ca0b1e2$var$load("9Vh0G"),
    $ab5f78b58ca0b1e2$var$load("hBIgN"),
    $ab5f78b58ca0b1e2$var$load("cD6Zr"),
    $ab5f78b58ca0b1e2$var$load("k3jER"),
    $ab5f78b58ca0b1e2$var$load("9wzNh"),
    $ab5f78b58ca0b1e2$var$load("8YSo7"),
    $ab5f78b58ca0b1e2$var$load("g7ggm"),
    $ab5f78b58ca0b1e2$var$load("9ldRJ"),
    $ab5f78b58ca0b1e2$var$load("50ame"),
    $ab5f78b58ca0b1e2$var$load("e7ZUf"),
    $ab5f78b58ca0b1e2$var$load("gL8bn"),
    $ab5f78b58ca0b1e2$var$load("1MlIV"),
    $ab5f78b58ca0b1e2$var$load("6iz6l"),
    $ab5f78b58ca0b1e2$var$load("4SCW2"),
    $ab5f78b58ca0b1e2$var$load("8bXcu"),
    $ab5f78b58ca0b1e2$var$load("1YiFu"),
    $ab5f78b58ca0b1e2$var$load("hv4mn"),
    $ab5f78b58ca0b1e2$var$load("Wowvf"),
    $ab5f78b58ca0b1e2$var$load("dek7I"),
    $ab5f78b58ca0b1e2$var$load("dYtBN"),
    $ab5f78b58ca0b1e2$var$load("6wr18"),
    $ab5f78b58ca0b1e2$var$load("kjZZD"),
    $ab5f78b58ca0b1e2$var$load("jytCl"),
    $ab5f78b58ca0b1e2$var$load("iGhIB"),
    $ab5f78b58ca0b1e2$var$load("3JSgG"),
    $ab5f78b58ca0b1e2$var$load("37ldp"),
    $ab5f78b58ca0b1e2$var$load("ffEVr"),
    $ab5f78b58ca0b1e2$var$load("9AXkC"),
    $ab5f78b58ca0b1e2$var$load("28arV"),
    $ab5f78b58ca0b1e2$var$load("hhss7"),
    $ab5f78b58ca0b1e2$var$load("jYUNl"),
    $ab5f78b58ca0b1e2$var$load("foy8I"),
    $ab5f78b58ca0b1e2$var$load("f1Pmi"),
    $ab5f78b58ca0b1e2$var$load("dP7ao"),
    $ab5f78b58ca0b1e2$var$load("hogcU"),
    $ab5f78b58ca0b1e2$var$load("i8eeg"),
    $ab5f78b58ca0b1e2$var$load("iFdoJ"),
    $ab5f78b58ca0b1e2$var$load("7EorR"),
    $ab5f78b58ca0b1e2$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.fe6a7f19.js.map
